<div
    class="visit"
    [ngStyle]="{
        'grid-template-columns': gridTemplateColumns,
        cursor: visit.cntProt ? 'pointer' : 'auto',
        'pointer-events': visit.cntProt ? 'auto' : 'none',
    }"
    (click)="historyItem(visit.keyId, visit.typeHistory)"
>
    <div class="visit__date">
        {{ getTekDay(visit.dtSort) }} в {{ getTime(visit.dtSort) }}
        <div style="color: #435b78; font-weight: 400">
            {{ getNameDay(visit.dtSort) }}
        </div>
    </div>

    <div class="visit__doctor">
        {{ visit.spec }} <br />
        <span class="name-capitalize">{{ visit.doctor }}</span>
    </div>

    <div class="visit__questions">
        <span> Исследование:</span>
        <span> Отделение:</span>
        <span> Филиал:</span>
    </div>
    <div class="visit__answers">
        <span> {{ visit.typeText }}</span>
        <span> {{ visit.depName }}</span>
        <span> {{ visit.depRootName }}</span>
    </div>

    <div class="visit__record">
        <div class="visit__record-wrapper">

            <div class="visit__result">
                <button
                    class="result-item"
                    *ngIf="visit.cntProt !== 0"
                    (click)="
                        gotToDownload(visit.keyId, visit.typeHistory, $event)
                    "
                >
                    <img
                        *ngIf="!pdfLoading"
                        class="result-item__img"
                        [src]="pdfImageURL"
                    />
                    <div
                        *ngIf="pdfLoading"
                        class="pdf-spinner"
                    ></div>
                </button>

                <ng-container *ngIf="visit.pacs.isLookupAvailable">
                    <button
                        class="result-item"
                        *ngIf="visit.pacs.canView"
                        (click)="
                            openDicomModal(
                                visit.typeHistory,
                                visit.keyId,
                                $event
                            )
                        "
                    >
                        <img
                            class="result-item__img"
                            src="./assets/icons/documents/dicom-view.svg"
                        />
                    </button>
                    <button
                        class="result-item"
                        type="button"
                        *ngIf="visit.pacs.canDownload"
                        (click)="
                            openDicomModal(
                                visit.typeHistory,
                                visit.keyId,
                                $event,
                                'DOWNLOAD'
                            )
                        "
                    >
                        <img
                            class="result-item__img"
                            src="./assets/icons/documents/dicom-download.svg"
                        />
                    </button>
                </ng-container>
            </div>
        </div>
    </div>
</div>
